/* HILO · Mobile home refresh — behaviour for the Figma 349:47 sections.
   [data-hed]     edition tabs: pills switch the product row; editions after
                  the first load on first use from
                  /collections/<handle>?section_id=hilo-home-editions
                  (the product page's "Bestsellers by category" uses the same
                  row, with data-hed-section / -skip / -avoid / -max: see editions())
   [data-hm-rev]  reviews: topic pills filter the cards, round arrows page
   [data-hvp]     USP strip: on phones one claim at a time, dots + autoplay
   [data-hf]      footer: link lists fold on phones, stay open on desktop
   The store photo row uses hilo-home.js ([data-hh-rail]). The product
   cards' photo arrows and swipe run from hilo-product-card.js, which
   listens on the document, so cards loaded later work too.
   Runs on load and again when the theme editor reloads a section. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function how() { return reduce ? 'auto' : 'smooth'; }
  function onFrame(fn) {
    var raf = 0;
    return function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; fn(); }); };
  }

  /* ---------- Horizontal rows: page by what fits, report the ends ---------- */
  function visibleItems(track) {
    return Array.prototype.filter.call(track.children, function (el) { return !el.hidden; });
  }
  function page(track, dir) {
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap) || 0;
    var first = visibleItems(track)[0];
    var unit = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    var view = track.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var per = Math.max(1, Math.floor((view + gap + 2) / unit));
    track.scrollBy({ left: dir * unit * per, behavior: how() });
  }
  function ends(track, prev, next) {
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  /* ---------- Shop by edition ---------- */
  /* Placeholder cards while an edition loads, in the product card's shape:
     the card's own photo box (.hilo-prod__img) with a shimmer inside. */
  function skeleton(n) {
    var html = '';
    for (var i = 0; i < n; i++) html += '<li class="hh-prail__item hm-ed__skel" aria-hidden="true"><span class="hilo-prod"><span class="hilo-prod__img"><span class="hm-ed__skel-img"></span></span><i></i><i></i></span></li>';
    return html;
  }
  function fallback(items, url, label) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    li.className = 'hm-ed__empty';
    a.href = url;
    a.textContent = (label || 'See the edition') + ' →';
    li.appendChild(a);
    items.innerHTML = '';
    items.appendChild(li);
  }
  function handleOf(a) {
    var m = /\/products\/([^\/?#]+)/.exec((a && a.getAttribute('href')) || '');
    return m ? m[1] : '';
  }
  function editions(root) {
    if (root.hedReady) return;
    root.hedReady = true;
    var list = root.querySelector('[role="tablist"]');
    var tabs = root.querySelectorAll('[role="tab"]');
    var all = root.querySelector('[data-hed-all]');
    var prev = root.querySelector('[data-hed-prev]');
    var next = root.querySelector('[data-hed-next]');
    /* Other copies of this row can name the section file that renders the
       cards (data-hed-section), a product handle to leave out — the one being
       viewed (data-hed-skip) —, other rows whose products shouldn't repeat here
       (data-hed-avoid, a selector) and how many cards to keep (data-hed-max).
       Product page: sections/hilo-pdp-bestsellers.liquid. */
    var sectionId = root.getAttribute('data-hed-section') || 'hilo-home-editions';
    var skip = root.getAttribute('data-hed-skip') || '';
    var avoid = root.getAttribute('data-hed-avoid') || '';
    var max = parseInt(root.getAttribute('data-hed-max'), 10) || 0;
    if (!tabs.length) return;

    function panelOf(tab) { return document.getElementById(tab.getAttribute('aria-controls')); }
    function track() {
      var p = root.querySelector('[role="tabpanel"]:not([hidden])');
      return p && p.querySelector('[data-hed-items]');
    }
    var sync = onFrame(function () { var t = track(); if (t) ends(t, prev, next); });

    function tidy(items) {
      var drop = {};
      if (skip) drop[skip] = 1;
      if (avoid) {
        try { each(document.querySelectorAll(avoid + ' a[href*="/products/"]'), function (a) { var h = handleOf(a); if (h) drop[h] = 1; }); } catch (e) {}
      }
      each(items.querySelectorAll('a[href*="/products/"]'), function (a) {
        var li = a.closest('li');
        if (drop[handleOf(a)] && li && li.parentNode === items) items.removeChild(li);
      });
      if (max) while (items.children.length > max) items.removeChild(items.lastElementChild);
    }

    function load(tab) {
      var panel = panelOf(tab);
      if (!panel || panel.hasAttribute('data-loaded') || panel.hedLoading) return;
      panel.hedLoading = true;
      var items = panel.querySelector('[data-hed-items]');
      var url = tab.getAttribute('data-url');
      items.innerHTML = skeleton(4);
      panel.setAttribute('aria-busy', 'true');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var got = doc.querySelector('[data-hed-items]');
          items.innerHTML = got ? got.innerHTML : '';
          tidy(items);
          if (!items.children.length) throw new Error('empty');
          panel.setAttribute('data-loaded', '');
        })
        .catch(function () { fallback(items, url, (tab.textContent || '').trim()); })
        .then(function () {
          panel.hedLoading = false;
          panel.removeAttribute('aria-busy');
          items.scrollLeft = 0;
          sync();
        });
    }

    function show(tab, focus) {
      each(tabs, function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = panelOf(t);
        if (p) p.hidden = !on;
      });
      if (focus) tab.focus({ preventScroll: true });
      if (list) {
        var l = tab.offsetLeft - list.offsetLeft;
        if (l < list.scrollLeft || l + tab.offsetWidth > list.scrollLeft + list.clientWidth) {
          list.scrollTo({ left: Math.max(0, l - 16), behavior: how() });
        }
      }
      if (all) all.setAttribute('href', tab.getAttribute('data-url'));
      load(tab);
      var t = track();
      if (t) t.scrollLeft = 0;
      sync();
    }

    each(tabs, function (tab, i) {
      tab.addEventListener('click', function () { show(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); show(tabs[j], true); }
      });
      /* Warm an edition while the pointer rests on its pill. */
      tab.addEventListener('pointerenter', function () { load(tab); }, { once: true });
    });
    if (prev) prev.addEventListener('click', function () { var t = track(); if (t) page(t, -1); });
    if (next) next.addEventListener('click', function () { var t = track(); if (t) page(t, 1); });
    each(root.querySelectorAll('[data-hed-items]'), function (t) { t.addEventListener('scroll', sync, { passive: true }); });
    window.addEventListener('resize', sync);
    sync();

    /* A row whose open panel arrives empty (no data-loaded) fills in when it
       comes near the screen, so it costs nothing further up the page. */
    var chosen = root.querySelector('[role="tab"][aria-selected="true"]') || tabs[0];
    var chosenPanel = panelOf(chosen);
    if (chosenPanel && !chosenPanel.hasAttribute('data-loaded')) {
      var start = function () { load(root.querySelector('[role="tab"][aria-selected="true"]') || chosen); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { io.disconnect(); start(); return; }
          }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      } else start();
    }
    /* A pill chosen on the server (not the first) is scrolled into view in its row. */
    if (list && chosen !== tabs[0]) {
      var l0 = chosen.offsetLeft - list.offsetLeft;
      if (l0 + chosen.offsetWidth > list.clientWidth) list.scrollLeft = Math.max(0, l0 - 16);
    }
  }

  /* ---------- What our clients say ---------- */
  function reviews(root) {
    if (root.revReady) return;
    root.revReady = true;
    var track = root.querySelector('[data-rev-track]');
    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    var chips = root.querySelectorAll('[data-rev-topic]');
    if (!track) return;
    var sync = onFrame(function () { ends(track, prev, next); });
    if (prev) prev.addEventListener('click', function () { page(track, -1); });
    if (next) next.addEventListener('click', function () { page(track, 1); });
    each(chips, function (chip) {
      chip.addEventListener('click', function () {
        var topic = chip.getAttribute('data-rev-topic');
        each(chips, function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        each(track.children, function (card) {
          card.hidden = !!topic && card.getAttribute('data-topic') !== topic;
        });
        track.scrollLeft = 0;
        sync();
      });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();
  }

  /* ---------- USP strip: one claim at a time on phones ---------- */
  function usp(root) {
    if (root.hvpReady) return;
    root.hvpReady = true;
    var track = root.querySelector('[data-hvp-track]');
    var dots = root.querySelectorAll('[data-hvp-dot]');
    if (!track || dots.length < 2) return;
    var secs = parseFloat(root.getAttribute('data-autoplay')) || 0;
    var timer = 0;
    var hold = false;
    function moving() { return track.scrollWidth > track.clientWidth + 2; }
    function index() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function go(i) { track.scrollTo({ left: i * track.clientWidth, behavior: how() }); }
    var sync = onFrame(function () {
      var i = index();
      each(dots, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    });
    function stop() { if (timer) { clearInterval(timer); timer = 0; } }
    each(dots, function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (secs > 0 && !reduce) {
      timer = setInterval(function () {
        if (hold || document.hidden || !moving()) return;
        var i = index() + 1;
        go(i >= track.children.length ? 0 : i);
      }, secs * 1000);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('pointerdown', stop, { passive: true });
      root.addEventListener('mouseenter', function () { hold = true; });
      root.addEventListener('mouseleave', function () { hold = false; });
      root.addEventListener('focusin', function () { hold = true; });
      root.addEventListener('focusout', function () { hold = false; });
    }
    sync();
  }

  /* ---------- Footer: fold the link lists on phones ---------- */
  function footer(root) {
    if (root.hfReady) return;
    root.hfReady = true;
    var cols = root.querySelectorAll('[data-hf-col]');
    if (!cols.length || !window.matchMedia) return;
    var wide = window.matchMedia('(min-width: 768px)');
    function apply() { each(cols, function (d) { d.open = wide.matches; }); }
    each(cols, function (d) {
      var s = d.querySelector('summary');
      if (s) s.addEventListener('click', function (e) { if (wide.matches) e.preventDefault(); });
    });
    apply();
    if (wide.addEventListener) wide.addEventListener('change', apply);
    else if (wide.addListener) wide.addListener(apply);
  }

  function init(scope) {
    scope = scope || document;
    function run(sel, fn) {
      if (scope.matches && scope.matches(sel)) fn(scope);
      each(scope.querySelectorAll(sel), fn);
    }
    run('[data-hed]', editions);
    run('[data-hm-rev]', reviews);
    run('[data-hvp]', usp);
    run('[data-hf]', footer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
